import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ClockIcon from 'icons/Clock.icon';
import PencilaltIcon from 'icons/Pencilalt.icon';
import PluscircleIcon from 'icons/Pluscircle.icon';
import UploadIcon from 'icons/Upload.icon';
import { YesNo } from 'models/Fields';
import { CREATE_LISTING_OPTIONS } from 'models/DealRoom';

const useSecondStepData = () => {
  const { t } = useTranslation();

  const createListingOptions = useMemo(
    () => [
      {
        label: (
          <>
            <PluscircleIcon />
            {t('draftListing')}
          </>
        ),
        value: CREATE_LISTING_OPTIONS.DRAFT_LISTING,
      },
      {
        label: (
          <>
            <ClockIcon />
            {t('setUpDealRoom')}
          </>
        ),
        value: CREATE_LISTING_OPTIONS.SET_DEAL_ROOM,
      },
    ],
    [t],
  );

  const draftOptions = useMemo(
    () => [
      {
        label: (
          <>
            <UploadIcon />
            {t('yesUploadIm')}
          </>
        ),
        value: YesNo.Yes,
      },
      {
        label: (
          <>
            <PencilaltIcon />
            {t('noWillDraftMyself')}
          </>
        ),
        value: YesNo.No,
      },
    ],
    [t],
  );

  return {
    createListingOptions,
    draftOptions,
  };
};

export default useSecondStepData;
